"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollActivator = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.throttle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ScrollActivator = exports.ScrollActivator = /*#__PURE__*/function (_React$Component) {
  _inherits(ScrollActivator, _React$Component);
  var _super = _createSuper(ScrollActivator);
  function ScrollActivator(props) {
    var _this;
    _classCallCheck(this, ScrollActivator);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleScroll", function (e) {
      var activatedState = _this.props.onScroll(e);
      if (_this.state.activatedState !== activatedState) {
        _this.setState({
          activatedState: activatedState
        });
      }
    });
    _this.state = {
      activatedState: false
    };
    _this.throttledHandleScroll = (0, _lodash["default"])(_this.handleScroll, props.throttleVal);
    return _this;
  }
  _createClass(ScrollActivator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.containerSelector) {
        this.containerSelector = document.querySelector(this.props.containerSelector);
      } else {
        this.containerSelector = window;
      }
      this.containerSelector.addEventListener('scroll', this.throttledHandleScroll);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.containerSelector.removeEventListener('scroll', this.throttledHandleScroll);
      this.throttledHandleScroll.cancel();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.state.activatedState);
    }
  }]);
  return ScrollActivator;
}(_react["default"].Component);
ScrollActivator.propTypes = {
  onScroll: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].func.isRequired,
  containerSelector: _propTypes["default"].node,
  throttleVal: _propTypes["default"].number
};
ScrollActivator.defaultProps = {
  containerSelector: undefined,
  throttleVal: 50
};